import axios from 'axios';
import router from '../Routes';

export default {
  namespaced: true,
  state: {
    timetrackings: [],
    isFetching: false,
    isReceiving: false,
    hasAlert: false,
    isDone: false,
    errorMessage: '',
    idToDelete: null,
  },
  mutations: {
    DELETED_TIMETRACKING(state, payload) {
      let indexToDelete = state.timetrackings.findIndex(timetracking => timetracking._id === payload._id);
      console.log(indexToDelete);
      let timetrackings = [...state.timetrackings];
      timetrackings.splice(indexToDelete, 1);
      state = Object.assign(state, {
        timetrackings: [...timetrackings],
        isDeleting: false,
        idToDelete: null,
      });
    },
    DELETING_TIMETRACKING(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload._id;
    },
    RECEIVED_TIMETRACKINGS(state, payload) {
      state.timetrackings = payload;
      state.isReceiving = false;
    },
    STOP_RECEIVING(state) {
      state.isReceiving = false;
    },
    RECEIVING_TIMETRACKINGS(state) {
      state.isReceiving = true;
    },
    TIMETRACKING_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    TIMETRACKING_SUCCESS(state) {
      state.isFetching = false;
      state.hasAlert= false;
      state.errorMessage = '';
      state.isDone = true;
    },
    TIMETRACKING_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert= false;
      state.errorMessage = '';
    },
    TIMETRACKING_DONE(state) {
      state.isFetching= false,
      state.hasAlert = false,
      state.isDone = false,
      state.errorMessage = ''
    }
  },
  actions: {
    async deleteTimeTrackingRequest({dispatch}, payload) {
      dispatch("deletingTimeTracking", payload);
      var token = localStorage.getItem('token')
      var url = 'https://api.accountxc.com:3100/delete/timetracking/' + payload._id;
      var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "delete",url: url,headers: header})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteTimeTracking", response.data);
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async getTimeTrackingsRequest({dispatch}){
      dispatch("receivingTimeTrackings");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/timetrackings';
      var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        response.data.sort((a,b) =>{
          if (b < a) return -1;
          if (a > b) return 1;
          return 0;
        });
        dispatch("receiveTimeTrackings", response.data);
      })
      .catch((error) => {
        console.error(error.response.data);
      });	
    },
    async getTimeTrackingsQuery({dispatch}, payload) {
      try{
        dispatch("receivingTimeTrackings");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/timetrackings/' + payload.employeeid;
        let response = await axios({method: "GET", url: url, headers: headers});
        console.log(response.data);
        dispatch("receiveTimeTrackings", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getTimeReportRequest({dispatch}, payload) {
      try{
        dispatch("receivingTimeTrackings");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/timetracking/byemployee/' + payload.employeeid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("stopReceiving");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    endTimeTracking({commit}){
      commit('TIMETRACKING_DONE');
      router.replace('/login');
    },
    createTimeTracking({dispatch}, payload) {
      dispatch('requestTimeTracking');
      var url;
      var data;
      var header;
      console.log(payload)
      if(payload.image !== undefined) {
        url = 'https://api.accountxc.com:3100/insert/timetracking/withimage';
        data = new FormData();
        data.append('image', payload.image, payload.imagename); 
        delete payload['image'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
        };
      } else {
        url = 'https://api.accountxc.com:3100/insert/timetracking';
        data = payload;
        header = {
          'Content-Type': 'application/json',
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(response => {
        dispatch('receiveTimeTracking', response.data);
      })
      .catch((error) => {
        dispatch('loginError', error.response.data.error);
        this.alertmessage = error.response.data.error;
      });	
    },
    deletingTimeTracking({commit}, payload) {
      commit("DELETING_TIMETRACKING", payload)
    },
    deleteTimeTracking({commit}, payload) {
      commit("DELETED_TIMETRACKING", payload)
    },
    receiveTimeTracking({dispatch}) {
      dispatch('receiveTimeTrackingSuccess');
    },
    receiveTimeTrackings({commit}, payload) {
      commit("RECEIVED_TIMETRACKINGS", payload)
    },
    stopReceiving({commit}, payload) {
      commit("STOP_RECEIVING", payload)
    },
    receivingTimeTrackings({commit}) {
      commit("RECEIVING_TIMETRACKINGS")
    },
    logoutUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('usertype');
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      axios.defaults.headers.common['Authorization'] = "";
      router.push('/login');
    },
    loginError({commit}, payload) {
      commit('TIMETRACKING_FAILURE', payload);
    },
    resetTimeTracking({commit}) {
      commit('TIMETRACKING_DONE');
    },
    receiveTimeTrackingSuccess({commit}) {
      commit('TIMETRACKING_SUCCESS');
      //router.push('/login');
    },
    requestTimeTracking({commit}) {
      commit('TIMETRACKING_REQUEST');
    },
  }
}
